import {DeleteForever as DeleteForeverIcon} from "@mui/icons-material";
import { useFormContext } from "react-hook-form";
import {Link} from "react-router-dom";

function AddressTableRows({ isAdding, deleteTableRow }) {
  const { register, formState: { errors } } = useFormContext()
  return (
    isAdding && (
      <tr>
          <td className="border">
            <input placeholder="Name or Company" type="text" {...register('company')} name="company" className={`form-control ${errors.company ? 'is-invalid' : ''}`}/>
          </td>
          <td className="border">
            <input placeholder="Number & Street" type="text" {...register('street1')} name="street1" className={`form-control ${errors.street1 ? 'is-invalid' : ''}`}/>
          </td>
          <td className="border">
            <input placeholder="Suburb" type="text" {...register('suburb')} name="suburb" className={`form-control ${errors.suburb ? 'is-invalid' : ''}`}/>
          </td>
          <td className="border">
            <select 
              {...register('state')} 
              className={`form-select ${errors.state ? 'is-invalid' : ''}`}
              defaultValue={""}
            >
              <option value="" hidden>State</option>
              <option value="ACT">ACT</option>
              <option value="NSW">NSW</option>
              <option value="NT">NT</option>
              <option value="QLD">QLD</option>
              <option value="SA">SA</option>
              <option value="TAS">TAS</option>
              <option value="VIC">VIC</option>
              <option value="WA">WA</option>
            </select>
          </td>
          <td className="border">
            <input placeholder="Postcode" type="text" {...register('postcode')} name="postcode" className={`form-control ${errors.postcode ? 'is-invalid' : ''}`}/>
          </td>
          <td className="border"></td>
          <td className="border"></td>
          <td className="border">
            <Link style={{cursor: 'pointer'}} onClick={()=>(deleteTableRow())}><DeleteForeverIcon/></Link>
          </td>
        </tr>
    )
  )
}

export default AddressTableRows;